import cookie from 'js-cookie'
import { ref, computed } from 'vue'
import { axiosInstance } from '../../../../shared/api-helper'
import { localeMaps, locale } from '../../../../shared/locales'

const COOKIE_KEY = '_zm_lang'
const COOKIE_EXPIRES_DAYS = 365

function getCookieDomain() {
  return document.body?.getAttribute('data-cd') || '.zoom.us'
}

export function useLanguageSwitcher() {
  const currentLanguage = ref(localeMaps[locale])

  const localeOptions = computed(() =>
    Object.entries(localeMaps).map(([key, value]) => ({ key, value }))
  )

  const handleCommand = (lang) => {
    const domain = getCookieDomain()
    cookie.set(COOKIE_KEY, lang, {
      expires: COOKIE_EXPIRES_DAYS,
      path: '/',
      domain,
      secure: true
    })

    const userId = window.microsDatas?.userId
    if (userId) {
      axiosInstance.post('/profile/saveLocale', { userId, locale: lang })
    }

    location.reload()
  }

  return {
    currentLanguage,
    localeOptions,
    handleCommand
  }
}
